import { Button, Form, Input } from "antd"
import Link from "next/link"

export function TwoFAForm({onSubmitCode , onChangePhone}){
  return (
    <Form
      name="login"
      layout="vertical"
      onFinish={(e)=>{onSubmitCode(e)}}>
      <Form.Item
        name="code"
        rules={[{ required: true, message: "Por favor ingresa el codigo recibido" }]}>
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
            Verificar Código
        </Button>
      </Form.Item>
    </Form>
  )
}